import { useEffect, useState } from "react";

import Button from "../shared/Button";

import { LOAN_TYPES } from "../../constants/loanTypes";
import { EMPLOYMENT_TYPES } from "../../constants/employmentTypes";
import Drawer from "../../../../common/drawer/Drawer";
import { Briefcase, Calendar, Landmark, MessageSquare, User, Wallet } from "lucide-react";
import FormSection from "../../../../common/FormSection/FormSection";
import { formatCurrency } from "../../utils/formatCurrency";

const INITIAL_FORM = {

    first_name: "",

    last_name: "",

    mother_name: "",

    mobile: "",

    email: "",

    loan_type: "",

    loan_amount: 0,

    tenure_months: 0,

    employment_type: "self_employed",

    monthly_income: 0,

    remarks: "",annual_turnover: 0,
company_vintage: 0,

};

export default function AddLeadDialog({

    open,

    onClose,

    onSave

}){

    const [form,setForm]=useState(INITIAL_FORM);

    const [saving,setSaving]=useState(false);

    useEffect(()=>{

        if(open){

            setForm(INITIAL_FORM);

        }

    },[open]);

    function update(key,value){

        setForm(previous=>({

            ...previous,

            [key]:value

        }));

    }

    async function submit(){

        if(!form.mobile.trim()){

            alert("Mobile Number is required.");

            return;

        }

        if(!form.loan_type){

            alert("Select Loan Type.");

            return;

        }

        if(!form.loan_amount){

            alert("Enter Loan Amount.");

            return;

        }

        try{

            setSaving(true);

            await onSave?.({

                ...form,

                loan_amount:Number(form.loan_amount),

                tenure_months:Number(form.tenure_months)||null,

                monthly_income:

                    form.employment_type==="salaried"

                    ?

                    Number(form.monthly_income)||null

                    :

                    null

            });

        }

        finally{

            setSaving(false);

        }

    }

    if(!open){

        return null;

    }

    return(

       <Drawer
        open={!!open}

    width={650}

    title="Lead Details"

    subtitle={

      ""

    }

    onClose={()=>onClose()}
>

    <FormSection
        title="Basic Information"
        description="Customer details"
        icon={<User size={18}/>}
    >

                <div className="crm-form-grid">

                  <div className="form-group">

    <label>

        First Name

    </label>

    <input

        value={form.first_name}

        onChange={e=>

            update(

                "first_name",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Last Name

    </label>

    <input

        value={form.last_name}

        onChange={e=>

            update(

                "last_name",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Mother Name

    </label>

    <input

        value={form.mother_name}

        onChange={e=>

            update(

                "mother_name",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Mobile Number

    </label>

    <input

        value={form.mobile}

        onChange={e=>

            update(

                "mobile",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Email Address

    </label>

    <input

        type="email"

        value={form.email}

        onChange={e=>

            update(

                "email",

                e.target.value

            )

        }

    />

</div>
</div>
                  </FormSection>

    <FormSection
        title="Loan Information"
        description="Requested loan details"
        icon={<Landmark size={18}/>}
    >
                <div className="crm-form-grid">
<div className="form-group">

    <label>

        Loan Type

    </label>

    <select

        value={form.loan_type}

        onChange={e=>

            update(

                "loan_type",

                e.target.value

            )

        }

    >

        <option value="">

            Select Loan Type

        </option>

        {

            LOAN_TYPES.map(type=>

                <option

                    key={type.value}

                    value={type.value}

                >

                    {type.label}

                </option>

            )

        }

    </select>

</div>

<div className="form-group">

    <label>

        Loan Amount (₹)

    </label>

    <input

        type="number"

        value={form.loan_amount}

        onChange={e=>

            update(

                "loan_amount",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Tenure (Months)

    </label>

    <input

        type="number"

        value={form.tenure_months}

        onChange={e=>

            update(

                "tenure_months",

                e.target.value

            )

        }

    />

</div>
</div>
                </FormSection>

    <FormSection
        title="Employment"
        description="Employment details"
        icon={<Briefcase size={18}/>}
    >
                <div className="crm-form-grid">

    <div className="form-group">

        <label>

            Employment Type

        </label>

        <select

            value={form.employment_type}

            onChange={e=>

                update(

                    "employment_type",

                    e.target.value

                )

            }

        >

            {

                EMPLOYMENT_TYPES.map(type=>

                    <option

                        key={type.value}

                        value={type.value}

                    >

                        {type.label}

                    </option>

                )

            }

        </select>

    </div>

    {

        form.employment_type === "salaried" &&

        <div className="form-group">

            <label>

                Monthly Income (₹)

            </label>

            <input

                type="number"

                value={form.monthly_income}

                onChange={e=>

                    update(

                        "monthly_income",

                        e.target.value

                    )

                }

            />

        </div>

    }


{
    form.employment_type === "business" &&

    <>

        <div className="form-group">

            <label>

                Annual Turnover (₹)

            </label>

            <input

                type="number"

                value={form.annual_turnover}

                onChange={e=>

                    update(

                        "annual_turnover",

                        e.target.value

                    )

                }

            />

        </div>

        <div className="form-group">

            <label>

                Monthly Earnings (₹)

            </label>

            <input

                type="number"

                value={form.monthly_income}

                onChange={e=>

                    update(

                        "monthly_income",

                        e.target.value

                    )

                }

            />

        </div>

        <div className="form-group">

            <label>

                Company Vintage (Years)

            </label>

            <input

                type="number"

                min="0"

                value={form.company_vintage}

                onChange={e=>

                    update(

                        "company_vintage",

                        e.target.value

                    )

                }

            />

        </div>

    </>

}
</div>
  </FormSection>

    <FormSection
        title="Initial Remark"
        description="Optional note about this lead."
        icon={<MessageSquare size={18}/>}
    >

                <textarea

                    rows={4}

                    placeholder="Write initial remark..."

                    value={form.remarks}

                    onChange={e=>

                        update(

                            "remarks",

                            e.target.value

                        )

                    }

                />

              </FormSection>

    <div className="crm-dialog-footer">

        <Button
            variant="secondary"
            onClick={onClose}
        >
            Cancel
        </Button>

        <Button
            loading={saving}
            onClick={submit}
        >
            Create Lead
        </Button>

    </div>
   <style>{`

.crm-dialog-overlay{

    position:fixed;

    inset:0;

    background:rgba(0,0,0,.45);

    display:flex;

    align-items:center;

    justify-content:center;

    z-index:9999;

}

.form-group{

    display:flex;

    flex-direction:column;

    gap:8px;

}

.form-group label{

    font-size:13px;

    font-weight:600;

    color:#475569;

}

.crm-dialog{

    width:760px;
    max-width:85vw;

    overflow:auto;

    background:#fff;

    border-radius:16px;

    padding:24px;

}

.crm-dialog-header{

    margin-bottom:20px;

}

.crm-section-title{

    font-size:16px;

    font-weight:600;

    margin:20px 0 12px;

}

.crm-form-grid{

    display:grid;

    grid-template-columns:repeat(2,1fr);

    gap:16px;

}

.crm-form-grid input,

.crm-form-grid select,

textarea{

    width:95%;

    padding:12px;

    border:1px solid #ddd;

    border-radius:8px;

    font-size:14px;

    outline:none;

}

.crm-form-grid input:focus,

.crm-form-grid select:focus,

.crm-dialog textarea:focus{

    border-color:#2563eb;

}

.crm-dialog-footer{

    display:flex;

    justify-content:flex-end;

    gap:12px;

    margin-top:24px;

}

@media(max-width:768px){

    .crm-form-grid{

        grid-template-columns:1fr;

    }

}

            `}</style>

</Drawer>


         

    );

}